import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  __,
  isMobile,
  wait,
  Event,
  decode,
  sendNotfication,
} from "../../../../Helper";
import socket from "../../../../Socket";
import C from "../../../../Constant";
import styled from "styled-components";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';  // Default Swiper styles
import 'swiper/css/navigation'; // If you need navigation styles
import 'swiper/css/pagination'; // If you need pagination styles
import { Autoplay } from 'swiper/modules';
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import './Marquee.css'; // We'll create this





const GridContainer = styled.div`
  display: grid;
  grid-gap: 16px; /* Space between items */
  padding: 16px;
  grid-template-columns: 1fr; /* Default for mobile */

  // Mobile view (1 column by default)
  @media (min-width: 351px) {
    grid-template-columns: repeat(2, 1fr); /* 2 columns for small tablets */
  }

  // Tablet view (3 columns)
  @media (min-width: 655px) {
    grid-template-columns: repeat(3, 1fr); /* 3 columns for tablets */
  }

  // Desktop view (4 columns)
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr); /* 4 columns for standard desktops */
  }

  // Large Desktop view (5 columns)
  @media (min-width: 1440px) {
    grid-template-columns: repeat(5, 1fr); /* 5 columns for large desktops */
  }

  // Extra large screens (6 columns)
  @media (min-width: 1600px) {
    grid-template-columns: repeat(6, 1fr); /* 6 columns for very large screens */
  }
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  
`;

const Title = styled.h3`
  padding: 0.5rem;
  margin: 0;
  font-size: 10px;
  text-align: left;
  color: rgb(152, 167, 181);
  text-transform:uppercase;
`;


const GridItem = styled.div`
background-color: transparent;
border-radius: 10px;
width: 60px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
transition: transform 0.3s ease;
display: flex;
overflow: hidden; 
height: auto; 

@media(max-width:400px){
    width: 3.5rem;
    
  }
`;


const ResponsiveImage = styled.img`
width: 100%;
min-width:60px; 
min-height:80px;
height: auto;
border-radius: 8px;

@media(max-width:400px){
min-width:60px; 
min-height:60px;
}
`;


class Games extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      col: "col-12",
      mdCol:3,
      isMin: false,
      loading: true,
      games: [],
      
    };
  }

  componentDidMount() {
    socket.emit(C.GAMES);

    if (isMobile()) {
      this.setState({ col: "col-4" });
    }

    window.addEventListener("resize", this.handleResize);

    wait(50).then(() => {
      this.handleResize();
    });

    Event.on("hide_games", () => {
      wait(50).then(() => {
        this.handleResize();
      });
    });

    socket.on(C.GAMES, (data) => {
      this.setState({ games: decode(data), loading: false });
    });
  }


  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const pageContent = document.querySelector("#page-content");

    if (pageContent !== null) {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      if (width < 700) {
        this.setState({ mdCol: 4, isMin: true });
      } else {
        this.setState({ mdCol: 3, isMin: false });
      }
    }
  };

  

  render() {
    let { games, col, mdCol, isMin } = this.state;
    const list = games.slice(0,18).map((game, i) => (
      <AddGame
        key={__.toString(i)}
        col={col}
        mdCol={mdCol}
        item={game}
        isMin={isMin}
      />
    ));

    

    return (
      <>
        <Row className={"home-game"}>
          {this.state.loading ? (
            <>
              <div className="ycenter text-center">
                <div className="spinner-grow text-white my-5" role="status" />
              </div>
            </>
          ) : (
            // list
            <div className="marquee-container">
            <div className="marquee-track">
              {/* Double the items for seamless looping */}
              {games.concat(games).map((game, i) => (
                <div key={`${game.id}-${i}`} className="marquee-item">
                  <AddGame item={game} />
                </div>
              ))}
            </div>
          </div>
          )}
        </Row>
      </>
    );
  }
}

class AddGame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  maintance = () => {
    sendNotfication("Under maintenance");
  };

  render() {
    let { mdCol, item, isMin } = this.props;
    let style;

    if (item.prefix === 'diamond') {
        mdCol = 6
        style = {
            width: 'auto'
        }
    }

    let disabled = false;

    // if(item.prefix === 'blackjack'){
    //     disabled = true;
    // }

  //   if(item.prefix === 'mine'){
  //     disabled = true;
  // }

  
  if(item.prefix === 'roulette'){
    disabled = true;
}


// if(item.prefix === 'high-or-low'){
//   disabled = true;
// }

// if(item.prefix === 'magic-wheel'){
//   disabled = true;
// }
// if(item.prefix === 'plinko'){
//   disabled = true;
// }



    return (
      <>
        {!disabled ? (

            <Link to={"#"}>          
              <GridItem>
              <ResponsiveImage  src={item.image} alt={item.name} />
              </GridItem>
              <Title>
                <p style={{whiteSpace:"nowrap",fontSize:"clamp(3px,3vw,7px)",marginBottom:"0px"}}>
                {item.name}
                </p>
              </Title>
            </Link>
      
        ) : (
          <Col
            xl={mdCol}
            sm={2}
            md={2}
            className={"col-4 mb-2 ovh animated fadeInUp"}
          >
            <Link to={"#"} onClick={this.maintance} className="game2-link">
              <div
                className={
                  item.prefix !== null ? "game2-image" : "game2-image orange"
                }
              >
                <img src={item.image} className="img-fluid" alt={item.name} />
              </div>
            </Link>
          </Col>
        )}
      </>
    );
  }
}

export default Games;
